"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import generalFormatter from "../../formatters/general";
import { AdjustmentCalculations } from "./adjustment_calculations";
import CarrierService from "../../services/carrier_service";
import quickpayHelper from "../../helpers/quickpay";
import _ from "underscore";
function adjustmentLine(amount, description, key) {
  return /* @__PURE__ */ jsxs("div", { className: "row", children: [
    /* @__PURE__ */ jsxs("div", { className: "small-3 column possible-adjustments__calculation-line", children: [
      /* @__PURE__ */ jsx("div", { className: "operation", children: "- " }),
      generalFormatter.currency(amount)
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "small-7 column", children: [
      "TMS Adjustment: ",
      description
    ] })
  ] }, key);
}
function adjustmentBreakdown(adjustment) {
  return adjustmentLine(adjustment.amount, adjustment.reason, adjustment.id);
}
function otherInvoiceBreakdown(invoice) {
  return /* @__PURE__ */ jsxs("div", { className: "row", children: [
    /* @__PURE__ */ jsxs("div", { className: "small-3 column possible-adjustments__calculation-line possible-adjustments__calculation-line--other-invoice", children: [
      /* @__PURE__ */ jsx("div", { className: "operation", children: "- " }),
      generalFormatter.currency(invoiceAmount(invoice))
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "small-7 column", children: [
      "Invoice #",
      invoice.number
    ] })
  ] }, invoice.id);
}
function quickpayDiscountMinimum() {
  return quickpayHelper.quickpayMinimum();
}
function invoiceAmount(invoice) {
  var amount = parseFloat(invoice.amountToPay || invoice.source_invoice_amount);
  return isNaN(amount) ? 0 : amount;
}
function possibleAdjustments(props, state) {
  if (hasAmountAdjustments(props, state)) {
    return /* @__PURE__ */ jsxs("div", { className: "possible-adjustments__factor-calculation", children: [
      /* @__PURE__ */ jsxs("div", { className: "row possible-adjustments__starting-calculation-line", children: [
        /* @__PURE__ */ jsx("div", { className: "small-3 column possible-adjustments__starting-amount", children: calculationStartingValue(props, state) }),
        /* @__PURE__ */ jsx("div", { className: "small-7 column", children: startingCalculationLabel(props) })
      ] }),
      possibleOtherInvoicesBreakdown(props),
      possibleAdjustmentsBreakdown(props),
      possibleQuickpayBreakdown(props, state),
      /* @__PURE__ */ jsxs("div", { className: "row possible-adjustments__factor-total-line", children: [
        /* @__PURE__ */ jsx("div", { className: "small-3 column possible-adjustments__total-amount", children: calculationEndingValue(props, state) }),
        /* @__PURE__ */ jsx("div", { className: "small-7 column possible-adjustments__total-label", children: endingCalculationLabel(props) })
      ] })
    ] });
  }
}
function startingCalculationLabel(props) {
  if (props.forExpectedAmount) {
    return "Expected Amount From TMS";
  } else if (props.carrierInvoice.quickpay_disposition === "applied_to_invoice") {
    return "Anticipated Invoice Amount";
  } else {
    return "Invoice Amount";
  }
}
function endingCalculationLabel(props) {
  if (props.forExpectedAmount) {
    return "Adjusted Expected Amount";
  } else if (props.carrierInvoice.quickpay_disposition === "applied_to_invoice" && (hasAdjustments(props) || hasOtherInvoiceAdjustments(props))) {
    return "Adjusted Expected Amount";
  } else if (props.carrierInvoice.quickpay_disposition === "applied_to_invoice") {
    return "Expected Amount";
  } else {
    return "Payment Amount";
  }
}
function possibleAdjustmentsBreakdown(props) {
  if (props.forExpectedAmount) {
    return hasAdjustments(props) ? _.map(adjustments(props), adjustmentBreakdown) : null;
  }
}
function possibleQuickpayBreakdown(props, state) {
  if (!props.forExpectedAmount) {
    if (props.carrierInvoice.quickpay_disposition === "not_applied_to_invoice" && hasQuickpayAdjustment(props, state)) {
      return /* @__PURE__ */ jsxs("div", { className: "row", children: [
        /* @__PURE__ */ jsxs("div", { className: "small-3 column possible-adjustments__calculation-line", children: [
          /* @__PURE__ */ jsx("div", { className: "operation", children: "-" }),
          generalFormatter.currency(
            calculations(
              props,
              state
            ).quickpayDiscountAmountFromCarrierInvoice()
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "small-7 column", children: [
          quickpayDiscountAmountUsed(props, state, "CarrierInvoice"),
          " ",
          "Quickpay Discount"
        ] })
      ] });
    } else if (props.carrierInvoice.quickpay_disposition === "applied_to_invoice" && hasQuickpayAdjustment(props, state)) {
      return /* @__PURE__ */ jsxs("div", { className: "row", children: [
        /* @__PURE__ */ jsxs("div", { className: "small-3 column possible-adjustments__calculation-line", children: [
          /* @__PURE__ */ jsx("div", { className: "operation", children: " + " }),
          generalFormatter.currency(
            calculations(props, state).quickpayDiscountAmountFromTMS()
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "small-7 column", children: [
          quickpayDiscountAmountUsed(props, state, "TMS"),
          " Quickpay Discount"
        ] })
      ] });
    }
  } else {
    return null;
  }
}
function possibleOtherInvoicesBreakdown(props) {
  if (props.forExpectedAmount) {
    return hasOtherInvoiceAdjustments(props) ? _.map(otherInvoices(props), otherInvoiceBreakdown) : null;
  }
}
function hasAmountAdjustments(props, state) {
  return hasQuickpayAdjustment(props, state) || hasOtherInvoiceAdjustments(props) || hasAdjustments(props);
}
function calculationStartingValue(props, state) {
  if (props.carrierInvoice.quickpay_disposition === "applied_to_invoice" && !props.forExpectedAmount) {
    return generalFormatter.currency(
      actualTotalFromTMS(props, state, true, true)
    );
  } else if (props.forExpectedAmount) {
    return generalFormatter.currency(actualTotalFromTMS(props, state));
  } else {
    return generalFormatter.currency(totalFromCarrierInvoice(props));
  }
}
function totalFromCarrierInvoice(props) {
  return invoiceAmount(props.carrierInvoice);
}
function calculationEndingValue(props, state) {
  if (props.carrierInvoice.quickpay_disposition === "applied_to_invoice" && !props.forExpectedAmount) {
    return generalFormatter.currency(actualTotalFromTMS(props, state, true));
  } else if (props.forExpectedAmount) {
    return generalFormatter.currency(
      actualTotalFromTMS(props, state, true, false)
    );
  } else {
    return generalFormatter.currency(
      calculations(props, state).actualTotalFromCarrierInvoice(
        true,
        quickpayAdjustmentFromCarrierInvoice(props, state)
      )
    );
  }
}
function quickpayAdjustmentFromCarrierInvoice(props, state) {
  return hasQuickpayAdjustment(props, state) ? calculations(props, state).quickpayDiscountAmountFromCarrierInvoice() : 0;
}
function quickpayAdjustmentFromTMS(props, state) {
  return hasQuickpayAdjustment(props, state) ? calculations(props, state).quickpayDiscountAmountFromTMS() : 0;
}
function calculations(props, state) {
  return AdjustmentCalculations(
    hasQuickpayAdjustment(props, state),
    hasOtherInvoiceAdjustments(props),
    hasAdjustments(props),
    props.expectedTotal,
    quickpayDiscountPercentage(state),
    quickpayDiscountMinimum(),
    totalFromCarrierInvoice(props),
    otherInvoicesAdjustment(props),
    otherAdjustment(props)
  );
}
function actualTotalFromTMS(props, state, withAdjustments, withQuickpayAdjustment) {
  return calculations(props, state).actualTotalFromTMS(
    withAdjustments,
    withQuickpayAdjustment,
    quickpayAdjustmentFromTMS(props, state)
  );
}
function hasAdjustments(props) {
  return !_.isEmpty(adjustments(props));
}
function otherAdjustment(props) {
  if (hasAdjustments(props)) {
    return _.chain(adjustments(props)).pluck("amount").map(parseFloat).reduce((memo, num) => memo + num, 0).value();
  } else {
    return 0;
  }
}
function adjustments(props) {
  return props.load.load.tms_adjustments;
}
function hasQuickpayAdjustment(props, state) {
  return quickpayHelper.hasQuickpayAdjustment(
    props.carrierInvoice,
    state.carrier
  );
}
function quickpayDiscountPercentage(state) {
  return quickpayHelper.quickpayPercentage(state.carrier);
}
function quickpayDiscountAmountUsed(props, state, source) {
  return calculations(props, state).quickpayDiscountAmountUsed(source);
}
function otherInvoicesAdjustment(props) {
  if (hasOtherInvoiceAdjustments(props)) {
    return _.chain(otherInvoices(props)).map(invoiceAmount).reduce((memo, num) => memo + num, 0).value();
  } else {
    return 0;
  }
}
function hasOtherInvoiceAdjustments(props) {
  return isDraftStatus(props) && otherInvoices(props).length > 0;
}
function isDraftStatus(props) {
  return props.carrierInvoice.state === "draft";
}
function otherInvoices(props) {
  return _.chain(props.load.carrier_invoices).filter((ci) => {
    return ci.id !== props.carrierInvoice.id;
  }).filter(function(ci) {
    return ci.state !== "deleted";
  }).filter(function(ci) {
    return ci.state !== "abandoned";
  }).filter((ci) => {
    return invoiceAmount(ci) > 0;
  }).value();
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      carrier: {}
    });
  }
  componentDidMount() {
    var id = this.props.carrierInvoice.carrier_id;
    CarrierService.carrierWithId(id).then((carrier) => {
      this.setState({ carrier });
    }).catch(_.identity);
  }
  render() {
    return /* @__PURE__ */ jsx("div", { children: possibleAdjustments(this.props, this.state) });
  }
}
